import React, {
  useCallback, useMemo, useContext, useState,
} from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip } from 'react-tippy';
import { networks } from '../../constants/networks';
import './styles.scss';
import { Context } from '../../stateManagement/store';
import useActionsHook from '../../stateManagement/actions';
import { getSupportedWallets } from '../../services/providerService';
import CloseIcon from '../Icons/CloseIcon';
import { LEDGER_LS_KEY, TREZOR_LS_KEY, WALLET_TYPES } from '../../constants/wallet';

const Connected = () => {
  const { dispatch, state } = useContext(Context);
  const [copiedText, setCopiedText] = useState('');
  const { account, accountType, networkId } = state;
  const [reset, setReset] = useState(true);
  const actions = useActionsHook(dispatch);

  const isDerivationSaved = useMemo(() => (accountType === WALLET_TYPES.trezor && localStorage.getItem(TREZOR_LS_KEY))
    || (accountType === WALLET_TYPES.ledger && localStorage.getItem(LEDGER_LS_KEY)), [accountType]);

  const handleClick = useCallback(() => {
    actions.closeModal(true);
  }, [actions]);

  const onCheckboxChange = useCallback(({ target }) => {
    setReset(target.checked);
  }, []);

  const handleCopy = useCallback(() => {
    setCopiedText('Copied to clipboard');
    setTimeout(() => { setCopiedText(''); }, 1000);
  }, []);

  const disconnect = useCallback(() => {
    actions.disconnect(true);
    if (reset) {
      localStorage.removeItem(TREZOR_LS_KEY);
      localStorage.removeItem(LEDGER_LS_KEY);
    }
  }, [actions, reset]);
  const change = useCallback(() => actions.disconnect(), [actions]);

  const walletInfo = getSupportedWallets().find(({ connectionType }) => connectionType === accountType);
  const formattedAddress = useMemo(() => `${account.slice(0, 5)}...${account.slice(-5)} `, [account]);
  const explorerUrl = useMemo(() => networks[networkId]?.blockExplorerUrls, [networkId]);

  return (
    <div className="web3-wc_modal-connected">
      <div className="web3-wc_modal_header">
        <CloseIcon className="web3-wc_close-modal-btn web3-wc_modal-icon-btn" onClick={handleClick}>X</CloseIcon>
        <h3>Wallet connected</h3>
      </div>

      <div className="we3b-wc_modal-wallet-body">
        <div className="web3-wc_modal-wallet-row">
          <span className="connected-with">
            Connected with {walletInfo?.label}
          </span>
          <button type="button" onClick={change}>Change</button>
        </div>
        <div className="web3-wc_modal-wallet-row">
          <div className="web3-wc_modal-wallet-icon"><walletInfo.Icon /></div>
          <div className="web3-wc_modal-wallet-acc" title={account}>{formattedAddress}</div>
        </div>
        <div className="web3-wc_modal-wallet-row">
          <div className="modal-link">
            <Tooltip hideOnClick={false} open={!!copiedText} theme="light" html={<span className="w3_wc-copied">{copiedText}</span>}>
              <CopyToClipboard text={account} onCopy={handleCopy}><span>Copy Address</span></CopyToClipboard>
            </Tooltip>
          </div>
          <a className="modal-link" target="_blank" rel="noopener noreferrer" href={`${explorerUrl}/address/${account}`}>
            View on Explorer
          </a>
        </div>
        <button type="button" onClick={disconnect} className="web3-wc_modal-button-disconnect">
          Disconnect wallet
        </button>
        {isDerivationSaved && (
          <div className="web3_wc_modal-reset-derivation">
            <div className="web3-wc_common-checkbox">
              <input type="checkbox" id="save-ledger-path" checked={reset} onChange={onCheckboxChange} />
              <label htmlFor="save-ledger-path">Reset Derivation path</label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Connected;
